import gql from "graphql-tag";

const GET_CEREBRO_EVENT_TYPES = gql`
  query CerebroEventTypes {
    cerebroEventTypes {
      id
      name
    }
  }
`;

const GET_CEREBRO_EVENTS = gql`
  query CerebroEvents(
    $startDate: String!
    $endDate: String
    $eventTypes: [Int!]!
  ) {
    cerebroEvents(
      startDate: $startDate
      endDate: $endDate
      eventTypes: $eventTypes
    ) {
      assetId
      assetName
      feedType
      playbackUrl
      title
      programStartTime
      programEndTime
      type
      blurb
      description
    }
  }
`;

export { GET_CEREBRO_EVENT_TYPES, GET_CEREBRO_EVENTS };



// WEBPACK FOOTER //
// ./src/httpClients/graphql/cerebro-queries.js